import { PATH } from "./path";

interface UserMenuItem {
  name: string;
  path: string;
}

export const MENU_USER_LAYOUT: UserMenuItem[] = [
  {
    name: "文件",
    path: PATH.User.Profile,
  },
  {
    name: "存款",
    path: PATH.User.Deposit,
  },
  {
    name: "提款",
    path: PATH.User.Withdraw,
  },
  {
    name: "帳務查詢",
    path: PATH.User.Transaction,
  },
  {
    name: "促銷活動",
    path: PATH.User.MemberPromotion,
  },
  {
    name: "錢包轉帳",
    path: PATH.User.wallet,
  },
  {
    name: "推薦",
    path: PATH.User.referral,
  },
  {
    name: "小費",
    path: PATH.User.tip,
  },
  {
    name: "VIP升級",
    path: PATH.User.vip,
  },
];
